import moment from 'moment-timezone';
import { getAccountTimeFormat } from 'shared/utils';
import {
  AccountInfoType,
  ColumnSettingsType,
  FormServFieldType,
  SegmentType,
  UserType,
} from '../../../shared/types';

export const getSegmentsColumnSettings = ({
  accountInfo,
  userInfo,
}: {
  accountInfo?: AccountInfoType;
  userInfo?: UserType;
}): ColumnSettingsType => ({
  name: {
    showInitial: true,
    filterable: true,
    disableReordering: true,
  },
  no_of_contacts: {
    showInitial: true,
    accessor: ({ contacts_count }: SegmentType) => contacts_count || 0,
    filterable: true,
    disableReordering: true,
  },
  created_at: {
    showInitial: true,
    filterable: true,
    accessor: ({ created_at }: SegmentType) =>
      created_at
        ? moment(new Date(created_at))
            .tz(accountInfo?.timezone || moment.tz.guess())
            .format(getAccountTimeFormat(accountInfo))
        : '',
  },
  updated_at: {
    showInitial: true,
    filterable: true,
    accessor: ({ updated_at }: SegmentType) =>
      updated_at
        ? moment(new Date(updated_at))
            .tz(accountInfo?.timezone || moment.tz.guess())
            .format(getAccountTimeFormat(accountInfo))
        : '',
  },
  creator_id: {
    showInitial: true,
  },
  updater_id: {
    showInitial: true,
  },
});

export const segmentFields: FormServFieldType[] = [
  {
    id: 'name',
    name: 'name',
    label: 'forms.labels.segment_name',
    type: 1,
  },
  {
    id: 'no_of_contacts',
    name: 'no_of_contacts',
    label: 'lists.list_fields.no_of_contact',
    type: 2,
  },
  {
    id: 'created_at',
    name: 'created_at',
    label: 'contacts.import_contact.default_fields.contact.created_at',
    type: 7,
  },
  {
    id: 'creator_id',
    name: 'creator_id',
    label: 'contacts.import_contact.default_fields.contact.creater_id',
    type: 1,
  },
  {
    id: 'updated_at',
    name: 'updated_at',
    label: 'contacts.import_contact.default_fields.contact.updated_at',
    type: 7,
  },
  {
    id: 'updater_id',
    name: 'updater_id',
    label: 'contacts.import_contact.default_fields.contact.updater_id',
    type: 1,
  },
];
